// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DOMEventEmitter = require("./DOMEventEmitter");

var _DOMEventEmitter2 = _interopRequireDefault(_DOMEventEmitter);

var _EventTargetMap = require("./EventTargetMap");

var _EventTargetMap2 = _interopRequireDefault(_EventTargetMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * UIEventObserver class provide performant/simple way to subscribe to browser DOM UI Events.
 * @public
 */
var UIEventObserver = function () {
    function UIEventObserver() {
        _classCallCheck(this, UIEventObserver);

        this._eventTargetMap = new _EventTargetMap2.default();
        this._eventHandlerMap = new _EventTargetMap2.default();
    }

    /**
     * registers the specified `handler` on the `target` element it's called `eventName`.
     * @param {Object} target target Element Node
     * @param {string} eventName event name
     * @param {Function} handler event handler
     * @returns {Function} unsubscribe handler
     * @public
     */


    _createClass(UIEventObserver, [{
        key: "subscribe",
        value: function subscribe(target, eventName, handler) {
            var _this = this;

            var domEventEmitter = this._eventTargetMap.get([eventName, target]);
            if (!domEventEmitter) {
                domEventEmitter = this._createEventEmitter(domEventEmitter);
                this._eventTargetMap.set([eventName, target], domEventEmitter);
                var _handler = function _handler(event) {
                    domEventEmitter.emit(event);
                };
                this._eventHandlerMap.set([eventName, target], _handler);
                target.addEventListener(eventName, _handler);
            }
            domEventEmitter.on(handler);
            return function () {
                _this.unsubscribe(target, eventName, handler);
            };
        }

        /**
         * registers the specified `handler` on the `target` element it's called `eventName`.
         * It is called at once difference from UIEventObserver#subscribe
         * @param {Object} target target Element Node
         * @param {string} eventName event name
         * @param {Function} handler event handler
         * @returns {Function} unsubscribe handler
         * @public
         */

    }, {
        key: "subscribeOnce",
        value: function subscribeOnce(target, eventName, handler) {
            var _this2 = this;

            var onceHandler = function onceHandler(event) {
                handler(event);
                _this2.unsubscribe(target, eventName, onceHandler);
            };
            return this.subscribe(target, eventName, onceHandler);
        }

        /**
         * removes the event `handler` previously registered with UIEventObserver#subscribe
         * @param {Object} target target Element Node
         * @param {string} eventName event name
         * @param {Function} handler event handler
         * @public
         */

    }, {
        key: "unsubscribe",
        value: function unsubscribe(target, eventName, handler) {
            var domEventEmitter = this._eventTargetMap.get([eventName, target]);
            if (!domEventEmitter) {
                return;
            }
            domEventEmitter.removeListener(handler);
            target.removeEventListener(eventName, handler);
            this._eventHandlerMap.delete([eventName, target]);
        }

        /**
         * unsubscribe all events with DOM Event
         * @public
         */

    }, {
        key: "unsubscribeAll",
        value: function unsubscribeAll() {
            var _this3 = this;

            this._eventTargetMap.forEach(function (target, eventName) {
                var handler = _this3._eventHandlerMap.get([eventName, target]);
                if (handler) {
                    _this3.unsubscribe(target, eventName, handler);
                }
            });
        }

        /**
         * if has a subscriber at least one, return true
         * @param {Object} targetElement
         * @param {string} domEventName
         * @returns {boolean}
         * @public
         */

    }, {
        key: "hasSubscriber",
        value: function hasSubscriber(targetElement, domEventName) {
            return this._eventHandlerMap.has([domEventName, targetElement]);
        }

        /**
         * @param eventName
         * @returns {DOMEventEmitter}
         * @private
         */

    }, {
        key: "_createEventEmitter",
        value: function _createEventEmitter(eventName) {
            return new _DOMEventEmitter2.default(eventName);
        }
    }]);

    return UIEventObserver;
}();

exports.default = UIEventObserver;
//# sourceMappingURL=UIEventObserver.js.map